import { isAllNao } from '../../utils-consultaSeguimento'
import {
  ConsultaSeguimentoPergunta06Model,
  ConsultaSeguimentoPergunta06PegarEnum,
} from './model-consultaSeguimentoPergunta06'

const pergunta06PegarEnum = Object.values(ConsultaSeguimentoPergunta06PegarEnum)

export const isPergunta06PegarAllNao = (value: ConsultaSeguimentoPergunta06Model['PERGUNTA_06_PEGAR']): boolean => {
  return isAllNao(value, pergunta06PegarEnum)
}
